module.exports = __webpack_public_path__ + "static/media/bottom-divider.97e09d65.svg";